<template>
  <div class="wrapper  layout-column">
    <div class="content">
      <div class="layout toolbar">
        <!--        <span class="wf-btn-normal primary" @click="addGroup"><i class="icon-addfolder"/> 新建分组</span>-->
        <span class="wf-btn-primary right" @click="chooseForm"><i class="el-icon-plus"/>创建新审批</span>
      </div>
      <div class="wf-manage-list" v-for="(group, index) in list" :key="group.CodeValue"
           :class="{stop: group.Type == 'disabled', divider: !group.List }">
        <div class="form-item-group">
          <div class="group-header ">
            <span class="title">{{ group.CodeName }}</span><span
              class="num">({{ group.List ? group.List.length : 0 }})</span>
          </div>
        </div>
        <div :id="'wf-manage-def-list-'+index">
          <div class="form-item layout" v-for="(item, index) in group.List" :key="index">
            <span :class="item.icon"></span>
            <div class="main">
              <div class="title">{{ item.name }}</div>
              <div class="desc">{{ item.description }}</div>
              <div class="date">{{ item.lastModificationTime || item.creationTime }} 更新</div>
              <div class="date" v-if="group.Type==='disabled'">类型：{{ item.groupName}} </div>
            </div>
            <div class="range flex">
              <div class="label">可见范围</div>
              <div class="value">全公司</div>
            </div>
            <div class="operate flex">
              <template v-if="group.Type != 'disabled'">
                <!--                <div class="simple-btn" @click="moveTo(item)">移动到</div>-->
                <div class="simple-btn" @click="setEnable(item, group, index)">停用</div>
                <div class="simple-btn" @click="modify(item)">编辑</div>
              </template>
              <template v-else>
                <div class="simple-btn" @click="deleteItem(item, group, index)">删除</div>
                <div class="simple-btn" @click="moveTo(item)">启用</div>
                <div class="simple-btn" @click="modify(item)">编辑</div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Message, MessageBox} from "@maidi/libs.pc";
import {Popup} from "@maidi/common";
import MoverGroup from "../../components/workflow/design/move-group";
import {WorkflowProcess} from "../../components/workflow/workflow";

export default {
  name: "form-manage",
  data() {
    return {
      list: [],
      sortableIndex: {},
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      WorkflowProcess.list().then(list => {
        this.list = list;
      })
    },
    modify(row) {
      this.$router.push(`/workflow-define?id=${row.id}`);
    },
    setEnable(item, group, index) {
      if (item.enabled) {
        MessageBox.confirm({
          message: "确定要停用吗?",
          confirmText: "确定",
          type: "warn",
          title: "提示"
        }).then(() => {
          WorkflowProcess.disable(item.id).then(res => {
            item.enabled = 0;
            item.groupId = "";
            this.list[this.list.length - 1].List.push(item);
            group.List.splice(index, 1);
            Message.success('已停用');
          })
        });
      }
    },
    async moveTo(item) {
      const group = this.list.find(group => group.id === item.groupId);
      if (group && group.List.find(_item => _item.enabled)) {
        await MessageBox.alert({
          message: `当前已有正在启用的${item.groupName}类型流程，请先停用后再启用本流程`
        })
        return
      }

      const {id, groupId, name, enabled} = item;
      Popup(MoverGroup, {id, groupId, name, enabled}).then(res => {
        this.getList();
      })
    },
    deleteItem(item, group, index) {
      MessageBox.confirm({
        message: "确定要删除吗?",
        confirmText: "确定",
        type: "warn",
        title: "提示"
      }).then(() => {
        WorkflowProcess.remove(item.id).then(res => {
          if (res) {
            Message.success('删除成功');
            group.List.splice(index, 1);
          }
        })
      });
    },
    chooseForm() {
      const template = '';
      // Popup(TemplateSelector).then((template) => {
      this.$router.push(`/workflow-define?template=${template}`);
      // });
    }
  },
};
</script>

<style scoped lang="scss">
@import "../../../assets/css/global";

.wrapper {
  background-color: #ebebeb;
}

[class^="workflow-icon-"] {
  margin: 5px 10px 5px 0
}

.content {
  background: #fff;
  width: 100%;
  height: 100%;
  overflow: auto;
  margin: 0 auto;

  .toolbar {
    margin: 10px 10px;
    margin-left: 15px;

    .title {
      font-size: 2rem;
      line-height: 30px;
      margin-right: 10px;
      color: $color-font-deep;
    }

    .wf-btn-primary {
      &.right {
        margin-left: auto;
      }

      [class^="el-icon-"] {
        font-size: 1.5rem;
        margin-right: 4px;
      }
    }

    .wf-btn-normal {
      border: 1px solid $color-primary;
      color: $color-primary;

      &:hover {
        background: #F8F8F8;
      }

      &.disable {
        border: 1px solid #c0c4cc;
        color: #c0c4cc;

        &:hover {
          background: #fff;
        }
      }
    }

  }

  .wf-manage-list {
    .form-item-group {
      .group-header {
        background: #f8f8f8;
        padding: 0px 15px;
        line-height: 40px;
        height: 40px;
        overflow: hidden;

        .title {
          color: #323334;
          font-size: 1.6rem;
        }

        .num {
          color: $color-font-light;
          margin-left: 5px;
        }
      }
    }

    .form-item {
      padding: 10px 15px;
      border-bottom: 1px solid #e0e0e0;
      position: relative;

      .layer-mask {
        left: 900px;
        top: 0px;
        right: 0px;
        bottom: 0px;
        background: #fff;
        opacity: .4;
        position: absolute;
      }

      &:last-child {
        border-bottom: none;
      }

      .sort-icon {
        line-height: 50px;
        font-size: 1.6rem;
        margin-right: 10px;
      }

      .form-img {
        width: 50px;
        height: 50px;
        float: left;
        margin-right: 12px;
        border-radius: 8px;
      }

      .main {
        width: 280px;
        line-height: 20px;
        border-right: 1px solid #e0e0e0;

        .title {
          color: $color-font-deep;
        }

        .desc {
          color: #858585;
          font-size: 1.2rem;
        }

        .date {
          color: #858585;
          font-size: 1.2rem;
        }
      }

      .range {
        padding-left: 18px;
        padding-top: 8px;
        line-height: 22px;
        font-size: 1.2rem;

        .value {
          color: #858585;
        }
      }

      .operate {
        padding-top: 20px;
      }

      .simple-btn {
        font-size: 1.2rem;
      }
    }

    &.stop {
      span {
        filter: grayscale(100%);
      }
    }

    &.divider {
      border-bottom: 1px solid #fff;
    }
  }
}

.simple-btn {
  color: $color-primary;
  margin-left: 10px;
  float: right;
  cursor: pointer;

  &.disable {
    opacity: .4;
    cursor: not-allowed;
  }
}

</style>
